"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptType = void 0;
// All the valid script types
var ScriptType;
(function (ScriptType) {
    ScriptType["Sql"] = "sql";
})(ScriptType = exports.ScriptType || (exports.ScriptType = {}));
